/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  isShowing: false,
  loading: false
});

export default function subscriptionReflash(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'HIDE_SUBSCRIPTION_REFLASH_MODAL':
      return INITIAL_STATE;
    case 'SHOW_SUBSCRIPTION_REFLASH_MODAL':
      return state.set('isShowing', true);
    case 'SUBSCRIPTION_UPGRADE_START':
      return state.set('loading', true);
    case 'SUBSCRIPTION_UPGRADE_STARTED':
    case 'SUBSCRIPTION_UPGRADE_FAILED':
      return state.set('loading', false);
    default:
      return state;
  }
}
